import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IGenerateTitleAudioIdsBody } from './generate-title-audio-ids-request';
import type { IGenerateTitleAudioIdsResponse } from './generate-title-audio-ids-response';
import { generateTitleAudioIdsResponseSchema } from './generate-title-audio-ids-response';

export async function generateTitleAudioIdsApi(
  body: IGenerateTitleAudioIdsBody,
): Promise<IValidatedResponse<IGenerateTitleAudioIdsResponse>> {
  return postRequest<IGenerateTitleAudioIdsResponse>({
    path: '/sys/challenges/audio/title-ids',
    body,
    schema: generateTitleAudioIdsResponseSchema,
  });
}
